import React from 'react';

import "./index-mobile-special-prize.scss";
import TermsDialog from "../../components/terms-dialog";

const HappyHoursMobileSpecial = (props) => {
  const { data } = props;

  const [open, setOpen] = React.useState(false);
  const openDialog = () => {
    setOpen(true);
  };
  const closeDialog = () => {
    setOpen(false);
  }

  const prize = data.prize_current.custom;

  return (
    <React.Fragment>
      <div className="bets-special-mobile-prize" onClick={openDialog}>
        <div className="hh-image">
          <img src={prize.image} alt="" />
        </div>
        <div className="hh-title">{data.name}</div>
        <div className="hh-footer">
          {prize.description}
        </div>
        <div className="hh-help">?</div>
      </div>
      <TermsDialog open={open} prize={prize} name={data.name} onClose={closeDialog} />
    </React.Fragment>
  );
}

export default HappyHoursMobileSpecial;